import React, { useState } from 'react'
import { addClientMachinery } from 'features/clientMachinery/clientMachinerySlice'
import { useDispatch } from 'react-redux'
import { NavBar } from '../../components/NavBar/NavBar'
import {
  Flex,
  TabsContainer,
  Tabs,
  PageWrapper,
  ContentWrapper,
  PageFooter,
} from '../../styling/GlobalStyles'
import { Button } from 'components/ui/Button/Button'
import { BackHeader } from 'components/ui/BackHeader/BackHeader'
import { MachinerySpecificationTab } from './MachinerySpecificationTab'
import { AppDispatch } from 'store'
import { IMachinery } from 'types/machinery.interface'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { CancelBtn } from 'components/Button/CancelBtn'

export const AddMachinery = () => {
  const [active, setActive] = useState('Specification')
  const [state, setState] = useState<IMachinery>({
    name: '',
    machineCategoryId: null,
    machineryModelId: null,
    ownership: null,
    costPerHour: null,
    hoursWorked: null,
    chassisNumber: null,
    licensePlate: null,
    fuelTankCapacity: null,
    status: null,
    machineCost: null,
    purchaseDate: null,
    maintenanceCosts: [{ year: 1000, q1: 1000, q2: 1000, q3: 1000, q4: 1000 }],
    yearOfManfacture: null,
    operations: [],
    machineCategory: null,
    machineryModel: null,
    usageType: null,
    vehicle: null,
    vehicleProvider: null
  })
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate()

  const handleSubmit = async () => {
    if (state.ownership == 1 && !state.machineCost) {
      toast.warning('Machine cost must be entered for selected ownership.')
      return
    }

    if (state.ownership == 2 && !state.costPerHour) {
      toast.warning('Machine cost must be entered for selected ownership.')
      return
    }

    if (!state.name || !state.machineCategory?.id || !state.machineryModel?.id) {
      toast.warning('All required fields must be filled.')
      return
    }

    const resp = await dispatch(addClientMachinery(state))
    if (resp.meta.requestStatus === 'fulfilled') {
      navigate(-1)
    }
  }



  return (
    <>
      <NavBar />
      <PageWrapper noFooter>
        <BackHeader title='Add Machinery' onBack={() => navigate(-1)}>
          <TabsContainer>
            <Tabs active={active === 'Specification'} onClick={() => setActive('Specification')}>
              Basic Info
            </Tabs>
            <Tabs active={active === 'Capabilities'} onClick={() => setActive('Capabilities')}>
              Capabilities
            </Tabs>
          </TabsContainer>
        </BackHeader>
        <ContentWrapper>
          <MachinerySpecificationTab
            state={state}
            setState={setState}
            handleSubmit={handleSubmit}
            isAdding={true}
          />
        </ContentWrapper>
      </PageWrapper>
      <PageFooter>
        <Flex gap='1rem'>
          <CancelBtn />
          <Button variant='primary' onClick={handleSubmit}>
            Save
          </Button>
        </Flex>
      </PageFooter>
    </>
  )
}
